/**
 * In-session pub-sub fired after notification settings are saved on the
 * server, so server-derived state (unread badges) can be re-fetched.
 *
 * `spaceId` is null when the alias-wide defaults changed (affects every Space).
 */

type Listener = (spaceId: string | null) => void;

const listeners = new Set<Listener>();

export function emitSpaceNotificationSettingsSaved(spaceId: string | null): void {
  for (const listener of [...listeners]) {
    try {
      listener(spaceId);
    } catch {
      // A failing subscriber must not prevent the others from being notified.
    }
  }
}

export function onSpaceNotificationSettingsSaved(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
